import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Web\ProductPage\ProductPageMediaclipProjectController::__invoke
* @see Http/Controllers/Web/ProductPage/ProductPageMediaclipProjectController.php:23
* @route '/product-page/{product}/mediaclip-project'
*/
const ProductPageMediaclipProjectController = (args: { product: string | number | { sku: string | number } } | [product: string | number | { sku: string | number } ] | string | number | { sku: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: ProductPageMediaclipProjectController.url(args, options),
    method: 'post',
})

ProductPageMediaclipProjectController.definition = {
    methods: ["post"],
    url: '/product-page/{product}/mediaclip-project',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Web\ProductPage\ProductPageMediaclipProjectController::__invoke
* @see Http/Controllers/Web/ProductPage/ProductPageMediaclipProjectController.php:23
* @route '/product-page/{product}/mediaclip-project'
*/
ProductPageMediaclipProjectController.url = (args: { product: string | number | { sku: string | number } } | [product: string | number | { sku: string | number } ] | string | number | { sku: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { product: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'sku' in args) {
        args = { product: args.sku }
    }

    if (Array.isArray(args)) {
        args = {
            product: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        product: typeof args.product === 'object'
        ? args.product.sku
        : args.product,
    }

    return ProductPageMediaclipProjectController.definition.url
            .replace('{product}', parsedArgs.product.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Web\ProductPage\ProductPageMediaclipProjectController::__invoke
* @see Http/Controllers/Web/ProductPage/ProductPageMediaclipProjectController.php:23
* @route '/product-page/{product}/mediaclip-project'
*/
ProductPageMediaclipProjectController.post = (args: { product: string | number | { sku: string | number } } | [product: string | number | { sku: string | number } ] | string | number | { sku: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: ProductPageMediaclipProjectController.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Web\ProductPage\ProductPageMediaclipProjectController::__invoke
* @see Http/Controllers/Web/ProductPage/ProductPageMediaclipProjectController.php:23
* @route '/product-page/{product}/mediaclip-project'
*/
const ProductPageMediaclipProjectControllerForm = (args: { product: string | number | { sku: string | number } } | [product: string | number | { sku: string | number } ] | string | number | { sku: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: ProductPageMediaclipProjectController.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Web\ProductPage\ProductPageMediaclipProjectController::__invoke
* @see Http/Controllers/Web/ProductPage/ProductPageMediaclipProjectController.php:23
* @route '/product-page/{product}/mediaclip-project'
*/
ProductPageMediaclipProjectControllerForm.post = (args: { product: string | number | { sku: string | number } } | [product: string | number | { sku: string | number } ] | string | number | { sku: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: ProductPageMediaclipProjectController.url(args, options),
    method: 'post',
})

ProductPageMediaclipProjectController.form = ProductPageMediaclipProjectControllerForm

export default ProductPageMediaclipProjectController